const getRndInteger = (min, max) => {
  return Math.floor(Math.random() * (max - min)) + min;
};

// setting max to a big number allows practically any number of images - use the modulo operation
const reducer = (state = getRndInteger(0, 10000), action) => {
  return state;
};

export { reducer as default };
